import React, { useEffect, useState } from "react";
import {
  Pressable,
  StyleSheet,
  View,
  Alert,
  ActivityIndicator,
  Modal,
} from "react-native";
import CompleteReg from "@assets/svg/CompleteReg";
import colors from "@constants/color";
import entityStyle from "@utils/entityStyle";
import {
  createLeaderPayment,
  completeLeaderPayment,
  getLeaderPaymentDetails,
} from "@services/api";
import { useDispatch, useSelector } from "react-redux";
import { actions as refreshActions } from "@reducers/refreshReducer";
import analytics from "@services/analytics";
import t from "@constants/localization";
import { ORDER_FLOW_EVENTS } from "@constants/analyticsEventsCT";
import { actions as authActions } from "@reducers/authReducer";
import Cross from "@assets/svg/Cross";
import { LEADER_STATES } from "@screens/Home/ClPaymentAndAddress";
import { getItem, setItem } from "@lib/storage";
import {
  IS_NEW_USER,
  PAYMENT_PENDING_MODAL,
  SHOW_IJ_FLOW,
} from "@constants/strings";
import CustomText from "./CustomText";

let trackEventPayload;
let ordrId = "";

const PATH = "screens/PlaceOrder/PlaceOrderView";
const ROOT_PATH = "screens/Home/Payment/Registration";

const ModalPoup = ({ visible, children }) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent
      visible={visible}
    >
      <View style={styles.modalBackGround}>
        <View style={styles.modalContainer}>{children}</View>
      </View>
    </Modal>
  );
};

const CompletePayment = (props) => {
  const [orderSubmitting, setOrderSubmitting] = useState(false);
  const [fetchingOrderItem, setFetchingOrderItem] = useState(true);
  const [orderItem, setOrderItem] = useState({});
  const [orderItemFailed, setOrderItemFailed] = useState(null);
  const [permissionModalVisible, setPermissionDeniedModalVisible] =
    useState(false);
  const { leader_state = "" } = useSelector(({ auth: { user } }) => user);
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      getItem(SHOW_IJ_FLOW).then((x) => {
        getItem(PAYMENT_PENDING_MODAL).then((day) => {
          const currentDay = new Date().getDay();
          const ppmDay = JSON.parse(day);
          if (
            !JSON.parse(x) &&
            currentDay === ppmDay &&
            leader_state === LEADER_STATES.PAYMENT_PENDING
          ) {
            setPermissionDeniedModalVisible(true);
            setItem(
              PAYMENT_PENDING_MODAL,
              JSON.stringify(currentDay + 1),
            );
          }
        });
      });
    }, 1500);

    getLeaderPaymentDetails()
      .then(({ data }) => {
        const { orderItem, refresh } = data;
        setOrderItem(orderItem);
        if (refresh) {
          dispatch(
            authActions.getUserDetailsByTokenRequest({
              reDir: false,
            }),
          );
        }
        setFetchingOrderItem(false);
      })
      .catch((e) => {
        setFetchingOrderItem(false);
        setOrderItemFailed(true);
      });
    return () => {};
  }, []);

  handlePlaceOrder = async () => {
    const payload = {
      sku_id: "CM00072",
      sku_type: "LEADER_PAYMENT",
      language: "hi",
      paymentMethod: "COD",
      groupBuy: false,
      fromCart: true,
      removeUnavailable: false,
      trackingInfo: {},
    };
    trackEventPayload = {
      payment_method: "COD",
      total_quantity: 1,
      total_items: 1,
    };
    try {
      setOrderSubmitting(true);
      analytics.trackEvent("Payment Widget Clicked", {
        amount: orderItem.payable_amount,
        source: "homepage",
      });
      const { data } = await createLeaderPayment(payload);
      ordrId = data.order_id;
      handleCompleteOrder("YES", ordrId, trackEventPayload);
    } catch (e) {
      setOrderSubmitting(false);
      Alert.alert("", t(`${PATH}/tryAgain`));
    }
  };

  handleCompleteOrder = async (is_cod, order_id) => {
    completeLeaderPayment({ is_cod, order_id })
      .then(async ({ data }) => {
        analytics.trackEvent("Payment Done");
        dispatch(
          authActions.getUserDetailsByTokenRequest({
            reDir: false,
          }),
        );
        dispatch(refreshActions.silentRefresh());
        setOrderSubmitting(false);
      })
      .catch((e) => {
        console.log(e);
        setOrderSubmitting(false);
        analytics.trackEvent(ORDER_FLOW_EVENTS.ORDER_CANCELLED, {
          payload: trackEventPayload,
        });
        Alert.alert("", t(`${PATH}/tryAgain`));
      });
  };

  const handleModalVisibility = () => {
    analytics.trackEvent("Payment Modal Clicked", {
      leader_state,
    });
    setPermissionDeniedModalVisible(false);
    handlePlaceOrder();
  };

  const closeModal = () => {
    setPermissionDeniedModalVisible(false);
  };

  const { custom_message } = orderItem;

  return (
    <>
      <ModalPoup visible={permissionModalVisible}>
        <Pressable onPress={closeModal} style={{ alignSelf: "flex-end" }}>
          <Cross width={14} height={14} />
        </Pressable>
        <View style={{ alignItems: "center" }}>
          <CompleteReg />
        </View>
        <View style={{ paddingLeft: 20, paddingBottom: 15, paddingTop: 35 }}>
          <CustomText
            style={{
              fontSize: 14,
              textAlign: "center",
            }}
          >
            {custom_message}
          </CustomText>
        </View>
        <Pressable
          style={styles.submitModalButton}
          onPress={handleModalVisibility}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {!orderSubmitting ? (
              <Pressable onPress={handleModalVisibility}>
                <CustomText
                  variant="subtitle_16"
                  style={styles.submitModalButtonText}
                >
                  {t(`${ROOT_PATH}/completeRegistration`)}
                </CustomText>
              </Pressable>
            ) : (
              <Pressable style={styles.submitModalButton}>
                <ActivityIndicator color="white" size="small" />
              </Pressable>
            )}
          </View>
        </Pressable>
      </ModalPoup>

      <View
        style={[
          entityStyle.entityContainer,
          {
            borderRadius: 10,
            overflow: "hidden",
            position: "relative",
            elevation: 1,
            marginBottom: 10,
            backgroundColor: "white",
          },
        ]}
      >
        <View
          style={{
            backgroundColor: "#fff",
            flexDirection: "row",
            paddingHorizontal: 15,
            padding: 16,
          }}
        >
          <View style={{}}>
            <CompleteReg />
          </View>
          <View style={{ flex: 1 }}>
            {fetchingOrderItem ? (
              <ActivityIndicator color="#E40046" size="small" />
            ) : (
              <>
                <View style={{ paddingHorizontal: 16, paddingTop: 4 }}>
                  <CustomText
                    bold
                    fontType="content1"
                    numberOfLines={3}
                    style={{
                      fontSize: 14,
                      lineHeight: 21,
                      color: "rgba(0, 0, 0, 0.86)",
                    }}
                  >
                    {custom_message}
                  </CustomText>
                </View>
                <View
                  style={{
                    justifyContent: "center",
                    marginTop: 12,
                    borderRadius: 10,
                    paddingHorizontal: 20,
                  }}
                >
                  {!orderSubmitting ? (
                    <Pressable
                      style={[styles.submitModalButton, { paddingVertical: 6 }]}
                      onPress={handlePlaceOrder}
                    >
                      <CustomText
                        variant="subtitle_16"
                        style={{
                          color: colors.white,
                          lineHeight: 24,
                          marginBottom: 0,
                          paddingHorizontal: 4,
                        }}
                      >
                        {t(`${ROOT_PATH}/completeRegistration`)}
                      </CustomText>
                    </Pressable>
                  ) : (
                    <Pressable style={styles.submitModalButton}>
                      <ActivityIndicator color="white" size="small" />
                    </Pressable>
                  )}
                </View>
              </>
            )}
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  modalBackGround: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: "90%",
    backgroundColor: "white",
    padding: 20,
    justifyContent: "center",
    alignContent: "center",
    borderRadius: 10,
    elevation: 20,
  },
  submitModalButton: {
    paddingVertical: 12,
    marginBottom: 0,
    backgroundColor: "#E40046",
    borderRadius: 6,
    alignItems: "center",
  },
  submitModalButtonText: {
    color: colors.white,
  },
  submitButton: {
    paddingHorizontal: 42,
    paddingVertical: 12,
    backgroundColor: "#E40046",
    borderRadius: 10,
    minWidth: "75%",
    marginBottom: "33%",
    alignItems: "center",
  },
  submitButtonText: {
    fontFamily: "Mulish-Bold",
    color: "white",
    fontSize: 20,
    lineHeight: 28,
    marginLeft: 8,
  },
  innerContaier: {
    backgroundColor: "#F6EEE9",
    flex: 1,
  },
});

export default CompletePayment;
